module.exports = __webpack_public_path__ + "static/media/image-ppt.288aedec.svg";